import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';
import ButtonRefreshIcon from '../../../assets/icons/refresh-svg.svg';
import PrimeTable from '../../../components/PrimeTable';
import PropConfigFilter from './PropConfigFilter';
import PropConfigHeader from './PropConfigHeader';
import storage from '../../../utils/storage';
import Sidebar from '../../../components/Sidebar';

const PropConfigList = () => {

    let navigate = useNavigate();

    const dispatch = useDispatch();

    const propConfigList = useSelector(
        (state) => state?.propconfig?.propconfigList,
    );

    const userInfo = useMemo(() => JSON.parse(storage.get('loginUser')), []);


    if (!userInfo) { 
        navigate("/login", { replace: true });
    }
   const { userRole, userId, siteId } = userInfo || {};

    const propConfig = useSelector((state) => state.propconfig.propconfig);


    const defaultParams = useMemo(() => ({
        pageno: 1,
        pagesize: 10,
        sort: 'createdOn',
        sortOrder: -1,
        status : 'Active'
    }), []);

    const [formValues, setFormValues] = useState(defaultParams);
    
    const handleReset = () => {
        dispatch(appActions.PROPCONFIG_GET_ALL_REQUEST(defaultParams));
    };

    useEffect(() => {
        dispatch(appActions.PROPCONFIG_GET_ALL_REQUEST(defaultParams));
    }, []);

    const handleRefresh = useCallback(() => {
        dispatch(appActions.PROPCONFIG_GET_ALL_REQUEST(defaultParams));
    }, [dispatch, defaultParams]);

    useEffect(() => {
        if (propConfig?.action === 'delete') {
            handleRefresh();
        }
    }, [propConfig, handleRefresh]);

    const handleSearch = useCallback(
        (params) => {

            const searchParams = {
                ...params,
                pagesize: params.pagesize || defaultParams?.pagesize,
                pageno: params.pageno || defaultParams?.pageno,
                sort: params.sort || defaultParams?.sort,
                sortOrder: params.sortOrder || defaultParams?.sortOrder,
            };

            dispatch(appActions.PROPCONFIG_GET_ALL_REQUEST(searchParams));
        },
        [dispatch],
    );

    const handleViewRedirect = (record) => {
        const data = propConfigList?.data?.find((t) => t.id == record.id);
        navigate('/ui/prop-confg/detail', { state: { data, isView: true } });
    };

    const handleEditRedirect = (record) => {
        const data = propConfigList?.data?.find((t) => t.id == record.id);
        navigate('/ui/prop-confg/detail', { state: { data, isEdit: true } });
    };

    const handleFormValuesChange = (values) => {
        setFormValues(values);
    };

    const handleDelete = useCallback((record) => {
        const { id } = record;
        dispatch(appActions.PROPCONFIG_DELETE_REQUEST({ id }));
    }, []);

    const actionTemplate = useCallback(
        (rowData) => (
            <div className="flex gap-10 justify-content-center">
                <span className="cursor-pointer tp" onClick={() => handleViewRedirect(rowData)} data-pr-tooltip="View">
                    <i className="pi pi-eye text-blue-500 text-base"></i>
                </span>
                <span className="cursor-pointer tp" onClick={() => handleEditRedirect(rowData)} data-pr-tooltip="Edit">
                    <i className="pi pi-pencil text-blue-500 text-base"></i>
                </span>
                <span className="cursor-pointer tp" onClick={() => handleDelete(rowData)} data-pr-tooltip="Delete">
                    <i className="pi pi-times-circle text-base text-danger"/>
                </span>
            </div>
        ),
        [handleViewRedirect, handleEditRedirect, handleDelete],
    );

    const onFilterChangeCallback  = useCallback(
        (event) => {

            const { sortField, sortOrder, rows, page } = event;
            
            const params = {...formValues, pagesize: rows, pageno: page, sort: sortField, sortOrder: sortOrder };

            setFormValues(prevFormValues => ({
                ...prevFormValues,
                sort: sortField, 
                sortOrder: sortOrder,
                pagesize: rows,
                pageno: page
            }));

            handleSearch(params); 
        },

        [handleSearch, formValues],
    );

    const propValueTemplate = row => {
        const { propValue } = row
        const logTestStr = JSON.stringify(propValue)
        return logTestStr
    }

    const columns = [
        { field: 'propCode', header: 'Property Code', sortable: true, width : '220px', maxWidth: '220px' },
        { field: 'propGroup', header: 'Property Group', sortable: true, width : '160px' },
        { field: 'propValue', header: 'Property Value', sortable: true,  template: propValueTemplate, maxWidth : '250px' },
        { field: 'status', header: 'Status', sortable: true,width : '90px' },
        { field: 'createdOn', header: 'Created On', sortable: true, width : '150px' },
        // { field: 'lastUpdated', header: 'Last Updated', sortable: true, width : '150px' },
        // { field: 'lastUpdatedBy', header: 'Last Updated By', sortable: true, width : '150px' },
    ];
    
    const renderList = () => {
      
        return (
            <div className="w-full">
            
                <PropConfigHeader />
                <div className="flex flex-min-height">
                    <Sidebar />
                    <div className="p-grid w-full pl-60px">
                        <h3 className="title">Prop Config Management</h3>
                        <PropConfigFilter
                            handleSearch={handleSearch}
                            handleReset={handleReset}
                            onFormValuesChange={handleFormValuesChange} 
                            userRole={userRole}
                        />
                        <PrimeTable
                            list={propConfigList}
                            columns={columns}
                            actionColumn={actionTemplate}
                            onFilterChangeCallback={(e) => {
                                onFilterChangeCallback(e);
                            }}
                            tableName='prop_configuration'
                            isLazy={true}
                            isExport={true}
                        />
                    </div>
                </div>
            </div>
        );
    };
    return <div className="form_height">{renderList()}</div>;
};

export default PropConfigList;
